import styled from 'styled-components';
import { borderRadius, boxShadow, compose, height, maxHeight, maxWidth, minHeight, minWidth, space, width } from 'styled-system';
import { borderRadiusAttrs, boxShadowAttrs, objectFit, objectPosition } from '../utils';
/**
 * @public
 */
export const Image = /*#__PURE__*/styled.img.attrs(props => ({
  ...borderRadiusAttrs(props),
  ...boxShadowAttrs(props)
})).withConfig({
  displayName: "Image",
  componentId: "sc-1x3ijma-0"
})(["display:block;", ";", ";", ""], objectFit, objectPosition, props => compose(width, height, maxHeight, maxWidth, minHeight, minWidth, space, borderRadius, boxShadow)(props));
Image.displayName = 'Image';
Image.defaultProps = {
  boxShadowColor: 'border',
  maxWidth: '100%'
};